var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNextVwIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.5206 12H11.4771C11.2003 12 10.9349 12.1099 10.7392 12.3056C10.5435 12.5013 10.4336 12.7667 10.4336 13.0435V29.7391C10.4336 30.0159 10.5435 30.2813 10.7392 30.477C10.9349 30.6727 11.2003 30.7826 11.4771 30.7826H36.5206C36.7973 30.7826 37.0627 30.6727 37.2584 30.477C37.4541 30.2813 37.564 30.0159 37.564 29.7391V13.0435C37.564 12.7667 37.4541 12.5013 37.2584 12.3056C37.0627 12.1099 36.7973 12 36.5206 12Z",
    stroke: "#1377D4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9112 30.7832L19.8242 36.0006",
    stroke: "#1377D4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0859 30.7832L28.1729 36.0006",
    stroke: "#1377D4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7383 36H30.26",
    stroke: "#1377D4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8421 18.2613L28.1113 17.5666C28.1567 17.4489 28.2365 17.3478 28.3404 17.2763C28.4442 17.2048 28.5672 17.1664 28.6933 17.166H29.2065C29.3326 17.1664 29.4556 17.2048 29.5595 17.2763C29.6633 17.3478 29.7432 17.4489 29.7886 17.5666L30.0577 18.2613L30.9714 18.787L31.7099 18.6743C31.8329 18.6576 31.9581 18.6779 32.0695 18.7325C32.1809 18.7871 32.2736 18.8736 32.3358 18.981L32.5861 19.4191C32.6503 19.5282 32.6798 19.6542 32.6709 19.7805C32.662 19.9067 32.615 20.0273 32.5361 20.1263L32.0792 20.7084V21.7598L32.5486 22.3418C32.6275 22.4408 32.6745 22.5614 32.6834 22.6877C32.6924 22.8139 32.6628 22.9399 32.5987 23.0491L32.3483 23.4872C32.2862 23.5946 32.1935 23.6811 32.082 23.7357C31.9706 23.7903 31.8454 23.8105 31.7225 23.7938L30.9839 23.6812L30.0702 24.2069L29.8011 24.9016C29.7557 25.0192 29.6758 25.1204 29.572 25.1919C29.4681 25.2633 29.3451 25.3018 29.219 25.3021H28.6933C28.5672 25.3018 28.4442 25.2633 28.3404 25.1919C28.2365 25.1204 28.1567 25.0192 28.1113 24.9016L27.8421 24.2069L26.9284 23.6812L26.1899 23.7938C26.0669 23.8105 25.9418 23.7903 25.8303 23.7357C25.7189 23.6811 25.6262 23.5946 25.564 23.4872L25.3137 23.0491C25.2495 22.9399 25.22 22.8139 25.2289 22.6877C25.2379 22.5614 25.2849 22.4408 25.3638 22.3418L25.8206 21.7598V20.7084L25.3512 20.1263C25.2724 20.0273 25.2253 19.9067 25.2164 19.7805C25.2075 19.6542 25.237 19.5282 25.3012 19.4191L25.5515 18.981C25.6137 18.8736 25.7064 18.7871 25.8178 18.7325C25.9292 18.6779 26.0544 18.6576 26.1774 18.6743L26.9159 18.787L27.8421 18.2613ZM27.6982 21.2341C27.6982 21.5661 27.8301 21.8844 28.0648 22.1192C28.2996 22.3539 28.6179 22.4858 28.9499 22.4858C29.2819 22.4858 29.6003 22.3539 29.835 22.1192C30.0698 21.8844 30.2016 21.5661 30.2016 21.2341C30.2016 20.9021 30.0698 20.5837 29.835 20.349C29.6003 20.1142 29.2819 19.9824 28.9499 19.9824C28.6179 19.9824 28.2996 20.1142 28.0648 20.349C27.8301 20.5837 27.6982 20.9021 27.6982 21.2341Z",
    stroke: "#1377D4",
    strokeWidth: 0.729575,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4847 24.7203V17.9778C15.4833 17.8627 15.513 17.7493 15.5704 17.6496C15.6279 17.5498 15.7112 17.4674 15.8115 17.4109C15.9118 17.3543 16.0254 17.3258 16.1405 17.3283C16.2556 17.3307 16.368 17.3641 16.4657 17.4249L22.2985 20.7961C22.3946 20.8529 22.4743 20.9337 22.5297 21.0307C22.585 21.1277 22.6142 21.2374 22.6142 21.349C22.6142 21.4607 22.585 21.5704 22.5297 21.6674C22.4743 21.7644 22.3946 21.8452 22.2985 21.902L16.4657 25.3624C16.3614 25.4294 16.2399 25.4648 16.1159 25.4642C15.992 25.4637 15.8708 25.4273 15.767 25.3594C15.6633 25.2915 15.5814 25.195 15.5313 25.0816C15.4812 24.9682 15.465 24.8427 15.4847 24.7203Z",
    stroke: "#1377D4",
    strokeWidth: 1.01776,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextVwIcon);
export default __webpack_public_path__ + "static/media/next-vw-icon.8eb010cf157d4d159dbf521ff5d55747.svg";
export { ForwardRef as ReactComponent };